<app-card-table [info]="info" (refresh)="refreshWallets()" (popupEvent)="popupClick($event)"></app-card-table>